import { render, staticRenderFns } from "./SetDuration.vue?vue&type=template&id=2b36980e&scoped=true"
import script from "./SetDuration.vue?vue&type=script&lang=js"
export * from "./SetDuration.vue?vue&type=script&lang=js"
import style0 from "./SetDuration.vue?vue&type=style&index=0&id=2b36980e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36980e",
  null
  
)

export default component.exports